import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CIPPaginatedTable from "../../components/CIPPaginatedTable";

const HistoricalCIPs = ({}) => {
  const { t } = useTranslation();
  const cips = useSelector((state) => state.cips);
  const selectedTrain = useSelector((state) => state.selTrain);
  const isCipsEmpty = !cips || cips.length === 0;
  const errorMessage = t("IdentifiedCIPStrings.noCip");

  return (
    <div>
      <>
        <CIPPaginatedTable
          selectedTrain={selectedTrain}
          // Export As CSV functionality is on hold
          // exportFileName={`${t("excelSheetNames.historicalCIPS")}.csv`}
          enableActions
          enableAdd
          {...(isCipsEmpty ? { errorMessage } : {})}
        />
      </>
    </div>
  );
};

export default HistoricalCIPs;
